import React from 'react';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const AreaItemActionInsert = ({
    onToggleCreateAreaEquipmentModal,
    onToggleDeleteAreaModal,
    onToggleEditAreaModal,
    node
}) => {
    if (node.name === 'Default Area') {
        return (
            <p className={classes.emptyActions}>No actions available.</p>
        );
    }

    return (
        <div className={classes.agentActions}>
            <ActionsPanelItem
                title="Edit Area"
                iconUrl="/assets/images/areaTreeIcon.svg"
                onClick={() => onToggleEditAreaModal(true)}
            />
            <ActionsPanelItem
                title="Add Equipment Serving this Area"
                iconUrl="/assets/images/equipmentTreeIcon.svg"
                onClick={() => onToggleCreateAreaEquipmentModal(true)}
            />
            <ActionsPanelItem
                title="Delete Area"
                iconUrl="/assets/images/deleteIconColor.svg"
                onClick={() => onToggleDeleteAreaModal(true)}
            />
        </div>
    );
};

AreaItemActionInsert.defaultProps = {

};

AreaItemActionInsert.propTypes = {

};

export default AreaItemActionInsert;
